export default ({
  pageState: { editorBlocks },
  data: { blockId, blockData, success, updatedAt }
}) => {
  if (!success)
    return { editorCroppingBlockId: null, editorHeaderStatus: 'error' };

  return {
    editorBlocks: {
      ...editorBlocks,
      [blockId]: {
        ...editorBlocks[blockId],
        data: blockData
      }
    },
    editorCroppingBlockId: null,
    editorHeaderStatus: 'saved',
    editorHeaderUpdatedAt: updatedAt,
    editorIsDraft: true
  };
};
